import React from 'react';
import { inject } from 'mobx-react';
import { Link } from 'react-router-dom';

import { SectionLayout } from 'layouts/section';
import { ImageComponent as Image } from 'components/image';
import notFoundImage from 'static/images/404.jpg';

const styles = require('./not-found-page.styles.scss');


@inject('analyticsStore')
export class NotFoundPage extends React.Component {
  componentDidMount() {
    this.props.analyticsStore.pageview('/not-found');
  }

  render() {
    return (
      <div className={styles.NotFoundPage}>
        <SectionLayout className={styles.Section}>
          <Image width={350} src={notFoundImage} className={styles.Image} />
          <h3>Seite nicht gefunden</h3>
          <Link to='/'>Startseite</Link>
        </SectionLayout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/not-found/not-found.page.jsx